import { UserRole } from 'gql.generated'
import { isArray } from 'lodash'
import { User } from 'model'
import { useAuthenticationQuery } from './useAuthentication.generated'

export type Principal = User

export class Authentication {
  public user?: Principal

  constructor(user?: Principal, public readonly refetch?: () => {}) {
    this.user = user
  }

  public get isAuthenticated() {
    return !!this.user
  }

  public hasUserRole(userRole: UserRole | UserRole[]) {
    if (this.user && this.user.roles) {
      if (isArray(userRole)) {
        return userRole.reduce(
          (prev, role) => prev || this.user!.roles!.includes(role),
          false
        )
      } else {
        return this.user.roles.includes(userRole)
      }
    }
    return false
  }
}

export const useAuthentication = () => {
  const { data, error, refetch } = useAuthenticationQuery()

  if (error) {
    throw error
  }

  const user = data ? data.principal || undefined : undefined

  return new Authentication(user, refetch)
}
